module.exports = __webpack_public_path__ + "static/portico_05-b09f99b06737b87d721704a533758d14.jpg";